import { ChallengeService } from '@duck/api-definitions'
import type { INotebookContent } from '@jupyterlab/nbformat'
import { WysiwygEditor } from '@/components/WysiwygEditor/WysiwygEditor'
import { ReadOnlyPythonNotebook } from '@/components/PythonNotebook/ReadOnlyPythonNotebook'

export interface SolutionContentProps {
  workState: ChallengeService.WorkState | undefined
  /** Applied to the WysiwygEditor branch only; ReadOnlyPythonNotebook ignores it. */
  className?: string
}

export const SolutionContent = ({ workState, className }: SolutionContentProps) => {
  if (workState?.chosenWeapon === ChallengeService.TaskWeaponsOfChoiceEnum.Python) {
    return <ReadOnlyPythonNotebook notebook={workState.jNotebook as INotebookContent | undefined} />
  }
  return (
    <WysiwygEditor
      content={workState?.solution || ''}
      startingCharts={workState?.charts || {}}
      readOnly={true}
      className={className}
    />
  )
}
